(function () {
  function openFilterTabs(scope) {
    var root = scope || document;

    root.querySelectorAll('.filter-form .collapsible-trigger').forEach(function (trigger) {
      var contentId = trigger.getAttribute('aria-controls');
      var content = contentId ? document.getElementById(contentId) : null;

      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      if (content) {
        content.classList.add('is-open');
        content.style.height = 'auto';
      }
    });
  }

  function hasActiveFilters() {
    var params = new URLSearchParams(window.location.search);

    return Array.from(params.keys()).some(function (key) {
      return key.indexOf('filter.') === 0;
    });
  }

  function getClearFiltersUrl() {
    var url = new URL(window.location.href);
    var params = new URLSearchParams();
    var keepParams = ['sort_by', 'q', 'type'];

    keepParams.forEach(function (key) {
      var value = url.searchParams.get(key);

      if (value) {
        params.set(key, value);
      }
    });

    var query = params.toString();

    return url.pathname + (query ? '?' + query : '');
  }

  function syncClearFiltersButton() {
    var containers = document.querySelectorAll('#CollectionSidebar, #FilterDrawer');
    var showButton = hasActiveFilters();

    containers.forEach(function (container) {
      var activeTagsList = container.querySelector('.tag-list--active-tags');

      if (!activeTagsList) {
        return;
      }

      var clearButton = container.querySelector('.collection-filters__clear');

      if (!showButton) {
        if (clearButton) {
          clearButton.remove();
        }

        return;
      }

      if (!clearButton) {
        clearButton = document.createElement('a');
        clearButton.className = 'collection-filters__clear no-ajax';
        clearButton.textContent = 'Clear Filters';
        activeTagsList.parentNode.insertBefore(clearButton, activeTagsList);
      }

      clearButton.href = getClearFiltersUrl();
    });
  }

  function hideSoldOutColorFilters(scope) {
    var root = scope || document;

    root.querySelectorAll('.filter-form .tag--swatch').forEach(function (item) {
      var swatch = item.querySelector('.color-swatch');
      var label = '';

      if (swatch) {
        label = swatch.getAttribute('title') || swatch.textContent || '';
      }

      label = label.trim().toLowerCase();

      if (label.indexOf('sold out') !== -1) {
        item.classList.add('hide');
        item.setAttribute('hidden', 'hidden');
      }
    });
  }

  function init() {
    openFilterTabs();
    syncClearFiltersButton();
    hideSoldOutColorFilters();
  }

  document.addEventListener('input', function (event) {
    if (event.target.closest('.filter-form')) {
      window.setTimeout(syncClearFiltersButton, 0);
    }
  });

  document.addEventListener('collection:reloaded', function (event) {
    openFilterTabs();
    syncClearFiltersButton();
    hideSoldOutColorFilters(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
